import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as ResponseIcon } from "../../../assets/svg/modules/new-response.svg";

const ResponseOverview = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                response_overview: 1,
            },
        };
        dispatch(configure_getting_started_progress(obj));
    }, []);
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <ResponseIcon className="icon_content fill_svg" />
                        <span className="content_title">Response Overview</span>
                    </div>
                    <div className="text_content">
                        <p>{`Social Media Response module helps you provide real time customer support on social media platforms through a unified inbox and workflows designed to make your team productive. `}</p>
                        <p>{`Connect your social profiles and start getting all mentions, tags and DM’s in a unified inbox.  Set up agents and teams and map workflows to enable agents to respond to the messages.`}</p>
                        <p>If you are a manager, you can also view team and agent level analytics</p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/2qEHdt_pru8"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default ResponseOverview;
